var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifesaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.143 14.644 7.028 17.43c.919.368 1.922.57 2.972.57s2.053-.202 2.972-.57l-1.115-2.786A4.986 4.986 0 0 1 10 15a4.986 4.986 0 0 1-1.857-.356Zm-2.787-2.787A4.986 4.986 0 0 1 5 10c0-.656.126-1.283.356-1.857L2.57 7.028A7.978 7.978 0 0 0 2 10c0 1.05.202 2.053.57 2.972l2.786-1.115Zm2.787-6.5A4.986 4.986 0 0 1 10 5c.656 0 1.283.126 1.857.356l1.115-2.786A7.978 7.978 0 0 0 10 2c-1.05 0-2.053.202-2.972.57l1.115 2.786Zm6.5 2.786c.23.574.357 1.2.357 1.857 0 .656-.126 1.283-.356 1.857l2.786 1.115c.368-.919.57-1.922.57-2.972s-.202-2.053-.57-2.972l-2.786 1.115ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 7C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifesaver);
export default __webpack_public_path__ + "static/media/lifesaver.b8cc9e9d69fad5a2f1f8a0d10268204c.svg";
export { ForwardRef as ReactComponent };